export const ADMIN_USER_INACTIVE_API_ERROR = 4120;
export const ADMIN_USER_LOCKED_API_ERROR = 4142;
export const INVALID_LOGIN_CREDENTIAL_API_ERROR = 3020;
export const RECYCLED_PASSWORD_API_ERROR = 6005;
export const PASSWORD_REQUIREMENTS = 4114;
